import { h } from 'preact';

import Grid from '@mui/material/Grid';

import LazyClsIssueDetail from './lazyIssueDetail.jsx';

export default function LazyClsIssueDetails(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <LazyClsIssueDetail />
      </Grid>
    </Grid>
  );
}
